/**
 * <s-review-open> — opens the Judge.me "Write a review" form on the product page
 * when the URL hash is #write-review, so shoppers review without leaving the site.
 * Waits for Judge.me to render its widget, then scrolls to it and opens the form.
 */
class SReviewOpen extends HTMLElement {
  #observer = null;
  #timer = null;

  connectedCallback() {
    if (window.location.hash !== '#write-review') return;
    if (!this.#tryOpen()) {
      this.#observer = new MutationObserver(() => {
        if (this.#tryOpen()) this.#stop();
      });
      this.#observer.observe(this, { childList: true, subtree: true });
      this.#timer = setTimeout(() => this.#stop(), 15000);
    }
  }

  disconnectedCallback() {
    this.#stop();
  }

  #tryOpen() {
    const link = this.querySelector('.jdgm-write-rev-link');
    if (!link) return false;
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const form = this.querySelector('.jdgm-form-wrapper');
    const isOpen = form && form.offsetParent !== null;
    if (!isOpen) link.click();
    return true;
  }

  #stop() {
    this.#observer?.disconnect();
    this.#observer = null;
    clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-review-open')) customElements.define('s-review-open', SReviewOpen);
